import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function VoucherReceiveIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="63"
      height="65"
      viewBox="0 0 63 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.4929 37.0349C60.7145 52.5291 49.7058 65 32.616 65C17.3219 65 1.31641 55.1928 1.31641 37.0349C1.31641 3.40116 18.7272 0 35.8171 0C52.9069 0 62.4929 18.8769 62.4929 37.0349Z"
        fill="#E3F1FF"
      />
      <rect
        x="50.8727"
        y="20.4994"
        width="22.2215"
        height="40.1626"
        rx="7.15"
        transform="rotate(90 50.8727 20.4994)"
        fill="white"
        stroke="#4E7FFF"
        strokeWidth="1.7"
      />
      <mask
        id="path-3-outside-1_9308_9012"
        maskUnits="userSpaceOnUse"
        x="35.1992"
        y="33.1641"
        width="20"
        height="20"
        fill="black"
      >
        <rect fill="white" x="35.1992" y="33.1641" width="20" height="20" />
        <path d="M53.0018 44.1679C52.5424 47.9347 49.6988 50.9666 45.2843 50.9666C41.3336 50.9666 37.1992 48.5824 37.1992 44.1679C37.1992 35.9909 41.6966 35.1641 46.1111 35.1641C50.5256 35.1641 53.0018 39.7534 53.0018 44.1679Z" />
      </mask>
      <path
        d="M53.0018 44.1679C52.5424 47.9347 49.6988 50.9666 45.2843 50.9666C41.3336 50.9666 37.1992 48.5824 37.1992 44.1679C37.1992 35.9909 41.6966 35.1641 46.1111 35.1641C50.5256 35.1641 53.0018 39.7534 53.0018 44.1679Z"
        fill="#FEB940"
      />
      <path
        d="M53.0018 44.1679L54.6274 44.3661L54.6394 44.2673V44.1679H53.0018ZM37.1992 44.1679H38.8368H37.1992ZM51.3762 43.9696C51.0082 46.9878 48.7995 49.329 45.2843 49.329V52.6042C50.598 52.6042 54.0767 48.8817 54.6274 44.3661L51.3762 43.9696ZM45.2843 49.329C43.6127 49.329 41.9495 48.8194 40.7441 47.9135C39.5764 47.036 38.8368 45.7987 38.8368 44.1679H35.5616C35.5616 46.9516 36.8892 49.1136 38.7764 50.5318C40.6258 51.9217 43.0052 52.6042 45.2843 52.6042V49.329ZM38.8368 44.1679C38.8368 40.3649 39.8724 38.7235 40.968 37.9203C42.18 37.0317 43.9208 36.8017 46.1111 36.8017V33.5265C43.887 33.5265 41.1718 33.7098 39.0315 35.2789C36.7748 36.9334 35.5616 39.7939 35.5616 44.1679H38.8368ZM46.1111 36.8017C47.6717 36.8017 48.9313 37.587 49.8634 38.9397C50.8177 40.3245 51.3642 42.2388 51.3642 44.1679H54.6394C54.6394 41.6824 53.9479 39.0948 52.5604 37.0813C51.1508 35.0358 48.9651 33.5265 46.1111 33.5265V36.8017Z"
        fill="white"
        mask="url(#path-3-outside-1_9308_9012)"
      />
      <g clipPath="url(#clip0_9308_9012)">
        <path
          d="M45.7251 42.3681L45.1226 40.7718C44.98 40.3942 44.5343 40.2123 44.1276 40.3658C43.7209 40.5193 43.5065 40.9504 43.6491 41.328M45.2947 41.2279C45.1522 40.8502 45.3666 40.4192 45.7733 40.2657C46.1799 40.1121 46.6257 40.294 46.7683 40.6717L47.3708 42.268M42.4338 42.5683L42.3233 42.6101C41.922 42.7615 41.5932 43.0545 41.4093 43.4251C41.1888 43.8683 41.1989 44.3736 41.4364 44.7873L42.2609 46.2238C42.9831 47.4816 44.5964 48.0049 46.0552 47.4543L47.4467 46.929C49.0745 46.3146 49.9313 44.5915 49.3608 43.0801L48.4139 40.5716C48.2714 40.1939 47.8256 40.012 47.4189 40.1655C47.0122 40.319 46.7979 40.7501 46.9404 41.1278M42.7781 43.4805L41.3147 39.6038C41.1722 39.2261 41.3866 38.795 41.7933 38.6415C42.2 38.488 42.6457 38.6699 42.7883 39.0476L44.2516 42.9243"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M20.1471 32.0299C19.9829 33.4602 18.9667 34.6113 17.3892 34.6113C15.9774 34.6113 14.5 33.7061 14.5 32.0299C14.5 28.9253 16.1072 28.6113 17.6847 28.6113C19.2622 28.6113 20.1471 30.3538 20.1471 32.0299Z"
        fill="#D680E0"
      />
      <path
        d="M29.2603 32.0299C29.0962 33.4602 28.08 34.6113 26.5025 34.6113C25.0907 34.6113 23.6133 33.7061 23.6133 32.0299C23.6133 28.9253 25.2204 28.6113 26.798 28.6113C28.3755 28.6113 29.2603 30.3538 29.2603 32.0299Z"
        fill="#D680E0"
      />
      <path
        d="M38.3736 32.0299C38.2095 33.4602 37.1933 34.6113 35.6158 34.6113C34.204 34.6113 32.7266 33.7061 32.7266 32.0299C32.7266 28.9253 34.3337 28.6113 35.9112 28.6113C37.4888 28.6113 38.3736 30.3538 38.3736 32.0299Z"
        fill="#D680E0"
      />
      <path
        d="M47.4908 32.0299C47.3267 33.4602 46.3105 34.6113 44.7329 34.6113C43.3212 34.6113 41.8438 33.7061 41.8438 32.0299C41.8437 28.9253 43.4509 28.6113 45.0284 28.6113C46.606 28.6113 47.4908 30.3538 47.4908 32.0299Z"
        fill="#D680E0"
      />
      <defs>
        <clipPath id="clip0_9308_9012">
          <rect
            width="11.9607"
            height="11.9607"
            fill="white"
            transform="translate(37.3242 39.2236) rotate(-20.6799)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
